import { render, staticRenderFns } from "./ConfigureAccreditation.vue?vue&type=template&id=321b5ae0&scoped=true&"
import script from "./ConfigureAccreditation.vue?vue&type=script&lang=js&"
export * from "./ConfigureAccreditation.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureAccreditation.vue?vue&type=style&index=0&id=321b5ae0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b5ae0",
  null
  
)

export default component.exports